import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Button, ButtonType } from '@/components/atoms/button'
import { ReloadButton } from '@/components/atoms/reload-button'
import { AccommodationPaging } from '@/components/molecules/accommodation-paging'
import { headerBarLeftWrapperStyle, mainContainerHeaderStyle } from '@/constants/layout'
import { reloadWrapperStyle } from '@/components/pages/accommodation-management/list-layout'
import { RESERVATION_TASK_PAGE_SIZE, ReservationTaskHandlingStatus } from '@/models/reservation/reservation-task'
import { BulkHandlingStatusButton } from './bulk-handling-status-button'

type Props = {
  selectedCount: number
  total: number
  page: number
  isLoading: boolean
  isReadOnly: boolean
  /** 絞り込み条件を適用しているか。フィルターボタンの見た目を切り替える */
  isFiltering: boolean
  onToggleFilterPanel: () => void
  onReload: () => void
  onChangePage: (page: number) => void
  onBulkChangeHandlingStatus: (status: ReservationTaskHandlingStatus) => void
}

export const ReservationTaskToolbar: React.FC<Props> = props => {
  const { t } = useTranslation()
  return (
    <div css={[mainContainerHeaderStyle, toolbarStyle]}>
      <div css={headerBarLeftWrapperStyle}>
        {props.selectedCount > 0 ? (
          <>
            <div css={selectedCountStyle}>{t('reservationTask.SelectedCount', { count: props.selectedCount })}</div>
            <BulkHandlingStatusButton disabled={props.isReadOnly} onSelect={props.onBulkChangeHandlingStatus} />
          </>
        ) : (
          <>
            {/* 売掛管理の一覧と同じく、条件を適用しているときだけオレンジの見た目にする */}
            <Button
              buttonType={props.isFiltering ? ButtonType.Simple : ButtonType.NonStyle}
              icon={
                props.isFiltering ? require('@/static/images/icon_filter_active.svg') : require('@/static/images/icon_filter_disable.svg')
              }
              width={120}
              height={32}
              fontSize={12}
              onClick={props.onToggleFilterPanel}
            >
              {t('reservationTask.Filter')}
            </Button>
            <div css={reloadWrapperStyle}>
              <ReloadButton onClick={props.onReload} />
            </div>
          </>
        )}
      </div>
      <AccommodationPaging
        page={props.page}
        setPage={props.onChangePage}
        total={props.total}
        limit={RESERVATION_TASK_PAGE_SIZE}
        isDisabled={props.isLoading}
      />
    </div>
  )
}

const toolbarStyle = css({
  minWidth: 'auto',
})

const selectedCountStyle = css({
  fontSize: 14,
  fontWeight: 'bold',
})
